import ResultGrid from './result-grid';

export default ResultGrid;
